export default __webpack_public_path__ + "static/media/simProfile-9.7e7e9350.png";